export const authCodeApi = {
  authCodeGetApplyCode: '/rdp/console/api/v1/authcode/getapplycode',
  authCodeActivate: '/rdp/console/api/v1/authcode/activate',
  authCodeOffRemind: '/rdp/console/api/v1/authcode/offmind',
  authCodeGetConsoleMac: '/rdp/console/api/v1/authcode/getconsolemac',
  authCodeGetInactiveResult: '/rdp/console/api/v1/authcode/getinactiveresult',
  authCodeGetAuthedResourceInfo: '/rdp/console/api/v1/authcode/getauthedresourceinfo',
  authCodeGetCurAuthCode: '/rdp/console/api/v1/authcode/getcurauthcode'
};
